import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_2 = { class: "ion-margin-horizontal dark-font" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ion_label, { class: "ion-text-capitalize interstate-bold ion-text-wrap dark-font" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.value), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              disabled: option.quantity <= _ctx.lowerLimit,
              size: "small",
              fill: "outline",
              shape: "round",
              onClick: ($event: any) => (_ctx.updateSelectedQuantity(option, false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  ios: _ctx.remove,
                  md: _ctx.remove
                }, null, 8, ["ios", "md"])
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]),
            _createElementVNode("span", _hoisted_2, _toDisplayString(option.quantity), 1),
            _createVNode(_component_ion_button, {
              disabled: option.quantity >= option.limit,
              size: "small",
              fill: "outline",
              shape: "round",
              onClick: ($event: any) => (_ctx.updateSelectedQuantity(option, true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  ios: _ctx.add,
                  md: _ctx.add
                }, null, 8, ["ios", "md"])
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          _: 2
        }, 1024)
      ])
    ]))
  }), 128))
}